const ArrowLeft = props => (
  <svg className={props.className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <polygon points="17.77,3.77 16,2 6,12 16,22 17.77,20.23 9.54,12"/>
  </svg>
)

export default ArrowLeft
